import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromValidateGovIdPassportReducer from '../reducers/validate-gov-id-passport.reducer';
import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion

//#region VALIDATE GOV ID AND PASSPORT NUMBER SUB STATE
export const getValidateGovIdPassportState = createSelector(
  getAuthState,
  state => state[fromValidateGovIdPassportReducer.validateGovIdPassportFeatureKey]
);

export const getValidateGovIdPassportIsLoading = createSelector(
  getValidateGovIdPassportState,
  fromValidateGovIdPassportReducer.getValidGovIdPassportIsLoading
);

export const getValidateGovIdPassportFailure = createSelector(
  getValidateGovIdPassportState,
  fromValidateGovIdPassportReducer.getValidGovIdPassportFailure
);

export const getValidateGovIdPassportResponse = createSelector(
  getValidateGovIdPassportState,
  fromValidateGovIdPassportReducer.getValidGovIdPassportResponse
);

export const getValidateGovIdPassportRequest = createSelector(
  getValidateGovIdPassportState,
  fromValidateGovIdPassportReducer.getValidGovIdPassportRequest
);
